import { CommonQuery, ParamKey } from 'shared/types/QueryModel'

import { useCallback, useEffect } from 'react'

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'

interface UseAppSearchParamsProps {
  removeKeysOnChange?: ParamKey[]
  removeKeys?: ParamKey[]
}

let removeKeysOnChangeState: ParamKey[] = []

const setRemoveKeysOnChangeState = (keys: ParamKey[]) => {
  removeKeysOnChangeState = [...removeKeysOnChangeState, ...keys]
}

const removeRemoveKeysOnChangeState = (removeKeys: ParamKey[]) => {
  const newList = removeKeysOnChangeState.filter(
    (item) => !removeKeys.includes(item),
  )

  removeKeysOnChangeState = newList
}

export const useAppSearchParams = ({
  removeKeysOnChange,
  removeKeys,
}: UseAppSearchParamsProps = {}) => {
  const { pathname } = useLocation()

  const navigate = useNavigate()

  const [searchParams, setSearchParams] = useSearchParams()

  const deleteParamsRemoveKeysOnChangeState = () => {
    if (!removeKeysOnChangeState.length) return

    removeKeysOnChangeState?.forEach((key) => {
      deleteParam(key as ParamKey)
    })
  }

  const setParam = (key: ParamKey, value: string) => {
    deleteParamsRemoveKeysOnChangeState()
    onRemoveKeys()
    searchParams.set(key, value)
    setSearchParams(searchParams)
  }

  const setParams = (
    keys: { key: ParamKey; value: string }[],
    options?: { replace?: boolean },
  ) => {
    keys.forEach((param) => {
      searchParams.set(param.key, param.value)
    })

    setSearchParams(searchParams, { replace: options?.replace ?? false })
  }

  const deleteParam = (key: ParamKey) => {
    searchParams.delete(key)
    setSearchParams(searchParams)
  }

  const onRemoveKeys = () => {
    if (!removeKeys?.length) return

    deleteKeys(removeKeys)
  }

  const deleteKeys = (keys: ParamKey[], options?: { replace?: boolean }) => {
    keys.forEach((key) => {
      searchParams.delete(key)
    })
    setSearchParams(searchParams, { replace: options?.replace ?? false })
  }

  const getParam = (key: ParamKey) => {
    return searchParams.get(key)
  }

  const resetAllParams = () => {
    // @TODO
    // searchParams.forEach((_, key: string) => {

    //   searchParams.delete(key)
    // })
    // setSearchParams(searchParams)

    navigate(pathname)
  }

  const getAllParams = useCallback(() => {
    const params: { [key: string]: string } = {}

    searchParams.forEach((value, key: string) => {
      params[key as string] = value
    })

    return params as CommonQuery
  }, [searchParams])

  useEffect(() => {
    if (removeKeysOnChange?.length) {
      setRemoveKeysOnChangeState(removeKeysOnChange)
    }

    return () => {
      if (removeKeysOnChange?.length) {
        removeRemoveKeysOnChangeState(removeKeysOnChange)
      }
    }
  }, [removeKeysOnChange])

  return {
    setParam,
    deleteParam,
    getAllParams,
    resetAllParams,
    getParam,
    setParams,
    deleteKeys,
  }
}
